'use strict';

import _ from 'lodash-es';

var util = {
     filterArr: function (arr) {
        var finishedArr = new Array();

        arr.forEach(function (o) {
           if (typeof o === "object") {
               var finishedObj = new Object();

               Object.keys(o).forEach(function (k) {
                   if (!o[k]) { return; }
                   finishedObj[k] = o[k];
               });

               if (Object.keys(finishedObj).length > 0) {
                   finishedArr.push(finishedObj);
               }
           } else if (!!o) {
               finishedArr.push(o);
           }
        });

        return finishedArr;
    },

	filterObj: function(o) {
        var finishedObj = {};

        Object.keys(o).forEach(function (k) {
           if (!o[k]) { return; }
           else if (o[k] instanceof Array) {
              finishedObj[k] = this.filterArr(o[k]);
           } else {
              finishedObj[k] = o[k];
           }
        }, this);

        return finishedObj;
    },


    /**
     * @function
     * @description appends the parameter with the given name and value to the given url and returns the changed url
     * @param {String} url the url to which the parameter will be added
     * @param {String} name the name of the parameter
     * @param {String} value the value of the parameter
     */
    appendParamToURL: function (url, name, value) {
        // quit if the param already exists
        if (url.indexOf(name + '=') !== -1) {
            return url;
        }
        var separator = url.indexOf('?') !== -1 ? '&' : '?';

        return url + separator + name + '=' + encodeURIComponent(value);
    },

    /**
     * @function
     * @description remove the parameter and its value from the given url and returns the changed url
     * @param {String} url the url from which the parameter will be removed
     * @param {String} name the name of parameter that will be removed from url
     */
    removeParamFromURL: function (url, name) {
        if (url.indexOf('?') === -1 || url.indexOf(name + '=') === -1) {
            return url;
        }
        var hash;
        var params;
        var domain = url.split('?')[0];
        var paramUrl = url.split('?')[1];
        var newParams = [];
        // if there is a hash at the end, store the hash
        if (paramUrl.indexOf('#') > -1) {
            hash = paramUrl.split('#')[1] || '';
            paramUrl = paramUrl.split('#')[0];
        }
        params = paramUrl.split('&');
        for (var i = 0; i < params.length; i++) {
            // put back param to newParams array if it is not the one to be removed
            if (params[i].split('=')[0] !== name) {
                newParams.push(params[i]);
            }
        }
        return domain + '?' + newParams.join('&') + (hash ? '#' + hash : '');
    },

    /**
     * @function
     * @description appends the parameters to the given url and returns the changed url
     * @param {String} url the url to which the parameters will be added
     * @param {Object} params
     */
    appendParamsToUrl: function (url, params) {
        var _url = url;
        _.each(params, function (value, name) {
            _url = this.appendParamToURL(_url, name, value);
        }.bind(this));

        return _url;
    },
    /**
     * @function
     * @description extract the query string from URL
     * @param {String} url the url to extra query string from
     **/
    getQueryString: function (url) {
        var qs;
        if (!_.isString(url)) { return; }
        var a = document.createElement('a');
        a.href = url;
        if (a.search) {
            qs = a.search.substr(1); // remove the leading ?
        }
        return qs;
    },

    updateQueryStringParam: function (url, paramName, newVal) {
        var _url = url;

        if (_url.indexOf(paramName) === -1) {
            return _url;
        }

        var newParamObj = new Object();
        newParamObj[paramName] = newVal;

        _url = this.removeParamFromURL(_url, paramName);
        _url = this.appendParamsToUrl(_url, newParamObj);

        return _url;
    },

    getHashParam: function (paramName) {
        var output = "";

        var hashParams = window.location.hash.replace("#", "").split("&");
        for (var i = 0; i < hashParams.length; i++) {
            if (hashParams[i].indexOf(paramName) > - 1) {
                output = hashParams[i].split("=")[1];
            }
        }

        return output;
    },

    /**
     * @function
     * @description
     * @param {String}
     * @param {String}
     */
    elementInViewport: function (el, offsetToTop) {
        var top = el.offsetTop,
            left = el.offsetLeft,
            width = el.offsetWidth,
            height = el.offsetHeight;

        while (el.offsetParent) {
            el = el.offsetParent;
            top += el.offsetTop;
            left += el.offsetLeft;
        }

        if (typeof(offsetToTop) !== 'undefined') {
            top -= offsetToTop;
        }

        if (window.pageXOffset !== null) {
            return (
                top < (window.pageYOffset + window.innerHeight) &&
                left < (window.pageXOffset + window.innerWidth) &&
                (top + height) > window.pageYOffset &&
                (left + width) > window.pageXOffset
            );
        }

        if (document.compatMode === 'CSS1Compat') {
            return (
                top < (window.document.documentElement.scrollTop + window.document.documentElement.clientHeight) &&
                left < (window.document.documentElement.scrollLeft + window.document.documentElement.clientWidth) &&
                (top + height) > window.document.documentElement.scrollTop &&
                (left + width) > window.document.documentElement.scrollLeft
            );
        }
    },

    /**
     * @function
     * @description Appends the parameter 'format=ajax' to a given path
     * @param {String} path the relative path
     */
    ajaxUrl: function (path) {
        return this.appendParamToURL(path, 'format', 'ajax');
    },

    /**
     * @function
     * @description
     * @param {String} url
     */
    toAbsoluteUrl: function (url) {
        if (url.indexOf('http') !== 0 && url.charAt(0) !== '/') {
            url = '/' + url;
        }
        return url;
    },
    /**
     * @function
     * @description Loads css dynamically from given urls
     * @param {Array} urls Array of urls from which css will be dynamically loaded.
     */
    loadDynamicCss: function (urls) {
        var i, len = urls.length;
        for (i = 0; i < len; i++) {
            this.loadedCssFiles.push(this.loadCssFile(urls[i]));
        }
    },

    /**
     * @function
     * @description Loads css file dynamically from given url
     * @param {String} url The url from which css file will be dynamically loaded.
     */
    loadCssFile: function (url) {
        return $('<link/>').appendTo($('head')).attr({
            type: 'text/css',
            rel: 'stylesheet'
        }).attr('href', url); // for i.e. <9, href must be added after link has been appended to head
    },
    // array to keep track of the dynamically loaded CSS files
    loadedCssFiles: [],

    /**
     * @function
     * @description Removes all css files which were dynamically loaded
     */
    clearDynamicCss: function () {
        var i = this.loadedCssFiles.length;
        while (0 > i--) {
            $(this.loadedCssFiles[i]).remove();
        }
        this.loadedCssFiles = [];
    },

    /**
     * @function
     * @description Extracts all parameters from a given query string into an object
     * @param {String} qs The query string from which the parameters will be extracted
     */
    getQueryStringParams: function (qs) {
        if (!qs || qs.length === 0) { return {}; }
        var params = {},
            unescapedQS = decodeURIComponent(qs);
        // Use the String::replace method to iterate over each
        // name-value pair in the string.
        unescapedQS.replace(new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
            function ($0, $1, $2, $3) {
                params[$1] = $3;
            }
        );
        return params;
    },

    fillAddressFields: function (address, $form) {
        for (var field in address) {
            if (field === 'ID' || field === 'UUID' || field === 'key') {
                continue;
            }
            // if the key in address object ends with 'Code', remove that suffix
            // keys that ends with 'Code' are postalCode, stateCode and countryCode
            $form.find('[name$="' + field.replace('Code', '') + '"]').val(address[field]);
            // update the state fields
            if (field === 'countryCode') {
                $form.find('[name$="country"]').trigger('change');
                // retrigger state selection after country has changed
                // this results in duplication of the state code, but is a necessary evil
                // for now because sometimes countryCode comes after stateCode
                $form.find('[name$="state"]').val(address.stateCode);
            }
        }
    },
    /**
     * @function
     * @description Updates the number of the remaining character
     * based on the character limit in a text area
     */
    limitCharacters: function () {
        $('form').find('[data-character-limit]').each(function () {
            var characterLimit = $(this).data('character-limit');
            var charCountHtml = String.format(Resources.CHAR_LIMIT_MSG,
                '<span class="char-used-count"> 0 </span> <span class="char-allowed-count">' + '/' + characterLimit + '</span>');

            //if window size is small then char-count should be after
            var containerPlacement = $(this).parents('.material-input').find('div.char-count');
            if (!$(this).parent().find('.char-count').length) {
                var containerInsert = $('<div class="char-count"/>').insertBefore($(this));
             }

            var charCountContainer = containerPlacement;
            if (charCountContainer.length === 0) {
                charCountContainer = containerInsert;
            }
            
            charCountContainer.html(charCountHtml);
            // trigger the keydown event so that any existing character data is calculated
            $(this).change();
        });


        $('form').find('div.char-count').each(function () {
            $(this).contents().filter(function () {
                return this.nodeType === Node.TEXT_NODE;
            }).remove();
        });
    },
    characterLimitEvents: function() {
        var controlKeys = ['8', '13', '46', '45', '36', '35', '38', '37', '40', '39'];
    
        $('body')
            .on('keydown', '[data-character-limit]', function (e) {
                var text = $(this).val(),
                    charsLimit = $(this).data('character-limit'),
                    charsUsed = text.length;
    
                if ((charsUsed >= charsLimit) && (controlKeys.indexOf(e.which.toString()) < 0)) {
                    e.preventDefault();
                }
            })
            .on('change keyup mouseup', '[data-character-limit]', function () {
                    var text = $(this).val(),
                    charsLimit = $(this).data('character-limit'),
                    charsUsed = text.length,
                    charsRemain = charsLimit - charsUsed;
    
                if (charsRemain < 0) {
                    $(this).val(text.slice(0, charsRemain));
                    charsRemain = 0;
                }
    
                if (charsUsed <= charsLimit) {
                    $(this).closest('.field-wrapper').find('.char-remain-count').html(charsRemain);
                    $(this).closest('.field-wrapper').find('.char-used-count').html(charsUsed);
                }
            });
    },
    /**
     * @function
     * @description Binds the onclick-event to a delete button on a given container,
     * which opens a confirmation box with a given message
     * @param {String} container The name of element to which the function will be bind
     * @param {String} message The message the will be shown upon a click
     */
    setDeleteConfirmation: function (container, message) {
        $(container).on('click', '.delete', function () {
            return window.confirm(message);
        });
    },
    /**
     * @function
     * @description Scrolls a browser window to a given x point
     * @param {String} The x coordinate
     */
    scrollBrowser: function (xLocation) {
        $('html, body').animate({scrollTop: xLocation}, 500);
    },

    isMobile: function () {
        var mobileAgentHash = ['mobile', 'tablet', 'phone', 'ipad', 'ipod', 'android', 'blackberry', 'windows ce', 'opera mini', 'palm'];
        var idx = 0;
        var isMobile = false;
        var userAgent = (navigator.userAgent).toLowerCase();

        while (mobileAgentHash[idx] && !isMobile) {
            isMobile = (userAgent.indexOf(mobileAgentHash[idx]) >= 0);
            idx++;
        }
        return isMobile;
    },

    /**
     * @function getCookieSelector
     * @description Returns the cookie value
     **/
    getCookieSelector: function (cookieName) {
        var regularExpression = '(?:(?:^|.*;\\s*)' + cookieName + '\\s*\\=\\s*([^;]*).*$)|^.*$';
        var regExp = new RegExp(regularExpression, '');

        return document.cookie.replace(regExp, '$1');
    },

    /**
	 * @function getCookieValue
	 * @description Returns the cookie value
	 **/
	getCookieValue: function (cookieName) {
		var regex = new RegExp(`(^| )${cookieName}=([^;]+)`)
      	var match = document.cookie.match(regex)
      if (match) {
        return match[2]
      }
	},
    
    /**
     * @function setCookie
     *
     * @param {string} key - The cookie name
     * @param {string} value - The cookie value
     * @param {integer} minutes - The number of minutes to expire the cookie
     **/
    setCookie: function (key, value, minutes) {
        var duration = '';

        if (minutes) {
            var date = new Date();

            date.setTime(date.getTime() + (minutes * 60 * 1000));

            duration = ' expires=' + date.toGMTString() + ';';
        }

        document.cookie = key + '=' + value + ';' + duration + ' path=/';
    },

    /**
     * @function validateEmail
     *
     * @description Returns boolean
     * @param {string} emailAddress - The email address
     **/
     validateEmail: function (emailAddress) {
        var emailRegExp = new RegExp('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,3}$');

        return emailRegExp.test(emailAddress);
     },

    /**
     * @function validateMessage
     *
     * @description Returns boolean
     * @param {string} message - The message
     **/
     validateMessage: function (message) {
    	 var messageRegExp = /^[^\f˘¤§¨°˛ł´ˇ¸˝×<>]*$/;

         return messageRegExp.test(message);
      },
      
      /**
       * @function validateGiftBoxMessage
       *
       * @description Returns boolean
       * @param {string} message - The message
       **/
      validateGiftBoxMessage: function (message) {
    	 var messageRegExp = /[\w\W]/g;

         return messageRegExp.test(message);
     },

    /**
     * @function maximizeCheckoutSummary
     *
     * @description Maximizes/Expands the Order Checkout Summary
     **/
     maximizeCheckoutSummary: function () {
        if (SitePreferences.IS_CHECKOUT_MAXIMIZED) {
            $('.accordion-navigation').addClass('is-active');
            $('.accordion-title').attr('aria-expanded', true);
            $('.accordion-title').attr('aria-selected', true);
            $('#panel11a').css('display', 'block');
        }
     },
     countryModal : function(){
   
    	 if(!$('.country-selector-slot').children().length){
    		 $("#country-selector-container").addClass("country-slot-disabled");
    	 }
     },

    paraEndWithThreeDots : function (element, desktopklength, mobilelength) {
        var elementName = $(element);
        var count = $(window).width() > 991 ? desktopklength : mobilelength;
        elementName.each(function () {
            var elementNameNameVal = $(this).html();
            var elementNameNameUpdated = elementNameNameVal.slice(0, count) + (elementNameNameVal.length > count ? "..." : "");
            $(this).html(elementNameNameUpdated);
        });
    },
     
     /*
      *  This function provides calling country code for given ISO country code
      */
     getCallingCountryCode : function(countryCode){
    	if (!countryCode) {
    		return undefined;
    	}
    	
    	// ISO Country Code and country calling codes mapping
	    var callingCodesCountryMapping = {
	    	at:'+43',
	    	be:'+32',
	    	nl:'+31',
	    	lu:'+352',
	    	ie:'+353',
	    	es:'+34',
	    	bg:'+359',
	    	cy:'+357',
	    	cz:'+420',
	    	dk:'+45',
	    	ee:'+372',
	    	fi:'+358',
	    	gr:'+30',
	    	hu:'+36',
	    	lv:'+371',
	    	lt:'+370',
	    	lu:'+352',
	    	mt:'+356',
	    	pl:'+48',
	    	pt:'+351',
	    	ro:'+40',
	    	sk:'+421',
	    	si:'+386',
	    	se:'+46',
	    	de:'+49',
	    	fr:'+33',
	    	it:'+39',
	    	gb:'+44'
	    };
        
        return callingCodesCountryMapping[countryCode.toLowerCase()];
     },

     /*
      *  This function provides calling phone number prefix given ISO country code
      */
     getCallingPhoneNumPrefix: function(countryCode){
    	if (!countryCode) {
    		return undefined;
    	}
    	
        // ISO Country Code and mapping phone number mapping
        var callingPhoneNumPrefixMapping = {
            at:'0',
            be:'0',
            nl:'0',
            ie:'0',
            bg:'0',
            hr:'0',
            fi:'0',
            lt:'8',
            ro:'0',
            sk:'0',
            si:'0',
            se:'0',
            de:'0',
            fr:'0',
            gb:'0'
        };
            
        return callingPhoneNumPrefixMapping[countryCode.toLowerCase()];
     },

     /*
     *This function provides calling country code example for given ISO country code
     */
     getExamplePhoneNumber : function(countryCode){
    	var countyCodeExample = {
    		gb:'+441234567890',
    		fr:'+33612345678',
    		es:'+34123456789',
    		pt:'+351123456789',
    		de:'+491234567890123',
    		it:'+3912345678901',
    		nl:'+31123456789',
    		se:'+461234567890123',
    		ie:'+35312345678901',
    		dk:'+4512345678',
    		be:'+32123456789',
    		gr:'+301234567890',
    		at:'+431234567890123',
    		fi:'+358123456789012',
    		pl:'+48123456789',
    		ro:'+40123456789',
    		cz:'+420123456789012',
    		hu:'+36123456789',
    		sk:'+42112456789',
    		mt:'+35612345678',
    		lt:'+37012345678',
    		lu:'+35212345678901',
    		si:'+38612345678',
    		ee:'+3721234567890',
    		cy:'+35712345678901',
    		lv:'+37112345678',
    		bg:'+359123456789'
    	};
    	return countyCodeExample[countryCode.toLowerCase()]
     },
   
	/*
	 * This function pre-populates the calling country code in
	 * mobile phone number field on shipping page.
	 */
	prePopulateCallingCountryCode : function(countryCode) {
		if(countryCode){
			if( ($('input[name$="_phone"]').length > 0)){
		    	var callingCountryCode = this.getCallingCountryCode(countryCode);
		    	// $('input[name$="_phone"]').val(callingCountryCode);
		    	$('input[name$="_phone"]').attr('data-country-code', callingCountryCode);
		    }
		}
    },
    phoneAccountAddressModal : function() {
        $(document).on('focus', '#dwfrm_billing_billingAddress_addressFields_phone', function () {
            $(this).on("blur", function(e) {
                $('#dwfrm_billing_billingAddress_addressFields_country').blur();        
            });        
        });
    },
    postalAccountAddressModal : function() {
        $(document).on('focus', '#dwfrm_billing_billingAddress_addressFields_postal', function () {
            $(this).on("blur", function(e) {
                $('#dwfrm_billing_billingAddress_addressFields_country').blur();        
            });        
        });
    },
    phoneShippingAddressModal : function() {
        $(document).on('focus', '#dwfrm_shippingaddress__emea_phone', function () {
            $(this).on("blur", function(e) {
                $('#dwfrm_shippingaddress__emea_country').blur();        
            });        
        });
    },
    postalShippingAddressModal : function() {
        $(document).on('focus', '#dwfrm_shippingaddress__emea_postal', function () {
            $(this).on("blur", function(e) {
                $('#dwfrm_shippingaddress__emea_country').blur();       
            });        
        });
    },
	/*
	 * This function handle the remain
	 * country code with the phone number.
	 */
	handleCountryCodeUpdate : function(phone) {
		if(phone.length > 0){
	    	phone.off('keydown').on('keydown', function (e) {
				if ((e.keyCode == 8 || e.keyCode == 46) && phone.is(":focus") && phone.val() === phone.attr('data-country-code')) {
			      e.preventDefault();
				}
			});
		}
	},
	     
     /**
      * @function For customize [input type=file] box.
      * @description appends the values from [input type=file] to the [input type= text]
      */
     narsproupload : function(){
    	 $('#nars-pro-signup-form .inputfile').change(function(e){
    		$("#"+$(this).data("update")).val(e.target.files[0].name);
         });
     },
     /**
      * call function after time delay
      */
     delay : (function(){
    	  var timer = 0;
    	  return function(callback, ms){
    	  clearTimeout (timer);
    	  timer = setTimeout(callback, ms);
    	 };
    	})(),
    	
    	/**
    	 * CSRF update for post method ajax
    	 */
    	 updateWithCsrfInputAjax : function () {
    	 	$.ajaxPrefilter(function(options, originalOptions, jqXHR){
    	 		
    	 	   if (options.type.toLowerCase() === "post") {
    	 	        // initialize `data` to empty string if it does not exist
    	 	        options.data = options.data || "";
    	 	        var csrf_key = Constants.CSRF_TOKEN_NAME+"=";

    	 	        if(options.data.indexOf(csrf_key) === -1 && options.url.indexOf('Adyen-PaymentFromComponent') == -1){ //if request doesnt contain csrf_token then add
    	 	        	// add _token entry
        	 	        var csrf_token = $('meta[name="csrf-token"]').attr('content');
    	 	        	// add leading ampersand if `data` is non-empty
        	 	        options.data += options.data?"&":"";
    	 	        	options.data += csrf_key + csrf_token;
    	 	        }
    	 	    }
    	 	});
    	 },
    	 /**
    	  * Bind global events
    	  */
    	 bindGlobalEvents: function () {
    		 //Redirect user to the CSRF Failed page if CSRF error occurred.
    		 $(document).bind("ajaxComplete", function(jqXHRObj, status){
    			 if (status && status.responseJSON && status.responseJSON.isCSRFError) {
    				 window.location = Urls.csrffailed;
                     localStorage.removeItem("storeDetailsSection");
                     localStorage.removeItem("selectedStoreData");
                     localStorage.removeItem("royalMail-edit");
		             localStorage.removeItem("storedAddressData");
    			 }
    		 });
    	 },
    	 scrollToError : function(scrollingArea,errorDistance,animationTime) {
    		 try{
    			 scrollingArea.animate({
    				scrollTop:($(".reveal-overlay").css('display') == 'none') ? (errorDistance.offset().top  -($('.sticky-header').height() + $('.bx-creative').height() + $('.header-section').height() + $('.checkout-header-container').height() + 20)) : (errorDistance - 40)
	  			 },animationTime);
    		 }
    		 catch(error){
    			 return;
    		 }
    		 
         },
        openModalFromContentAsset : function(modalOpenTrigger) {
            modalOpenTrigger.on('click', function(e) {
               e.preventDefault();
               e.stopImmediatePropagation();
               var $this = $(this);
               $('.checkout-reinsurance-inner-wrapper').addClass("section-dark");
               $('.checkout-reinsurance-inner-wrapper').addClass("section-narspro-step3");
               var popupdata = $('.checkout-reinsurance-inner-wrapper');
               var popup = new Foundation.Reveal(popupdata);
               
               $.ajax({
                   url: util.appendParamToURL($this.attr('href'), 'format', 'ajax'),
                   method: 'GET'
               })
               .done(function (response) { 
                   if (response) {
                       popup.open();
                       $('.checkout-reinsurance-inner-wrapper').find('.modal-body .modal-content').html(response);
                   }
               });
           });    		 
        },
        parseQueryString : function (url) {
        	var urlParams = {};
        	url.replace(
        		new RegExp("([^?=&]+)(=([^&]*))?", "g"),
        		function ($0, $1, $2, $3) {
        			if (typeof $3 != "undefined") {
        				urlParams[$1] = $3;
        			}
        		}
        	);
        	return urlParams;
        },
        generalExtension : function() {
            var s = arguments[0];
            var i, len = arguments.length - 1;
    
            for (i = 0; i < len; i++) {
                var reg = new RegExp('\\{' + i + '\\}', 'gm');
    
                s = s.replace(reg, arguments[i + 1]);
            }
    
            return s;
        },
        scrollToTop: function(e) {
            e.preventDefault();
            var verticalOffset = typeof(verticalOffset) != 'undefined' ? verticalOffset : 0;
            var element = $('body');
            var offset = element.offset();
            var offsetTop = offset.top;
        
            $('html, body').animate({
                scrollTop: offsetTop
            }, 500, 'linear');
        },
        getFormattedPhoneNumber: function(customFoneNumber,selectedCountryCode) {
            if(customFoneNumber && selectedCountryCode){
                var countryCodePrefix = this.getCallingCountryCode(selectedCountryCode);
                var phoneNumPrefix = this.getCallingPhoneNumPrefix(selectedCountryCode);
                if(phoneNumPrefix && (customFoneNumber.charAt(0) == phoneNumPrefix)){
                    customFoneNumber = countryCodePrefix+''+customFoneNumber.slice(1);
                } else {
                    customFoneNumber = countryCodePrefix+''+customFoneNumber;
                }
                return customFoneNumber;
            }
            return '';
        },
        getPhoneNumWithCode : function() {
            if($('#dwfrm_billing_billingAddress_addressFields_phoneNumber').length === 0) { 
                return; 
            }
            $(document).on('focusout','input[class~="phonenumber"]', function() {
                var customFoneNumber = $('#dwfrm_billing_billingAddress_addressFields_phoneNumber').val();
                var selectedCountryCode = $('#dwfrm_billing_billingAddress_addressFields_country').val();
                if(customFoneNumber != 'null' && selectedCountryCode != 'null'){
                    var custFoneNumb = util.getFormattedPhoneNumber(customFoneNumber,selectedCountryCode);
                    $('#dwfrm_billing_billingAddress_addressFields_phone').val(custFoneNumb);		
                }
            });
        },
        editPhoneNumberWithCode: function() {
            if($('#dwfrm_shippingaddress__emea_phoneNumber').length === 0) { 
                return; 
            }
            $(document).on('focusout','input[class~="phonenumber"]', function() {
                var customFoneNumber = $('#dwfrm_shippingaddress__emea_phoneNumber').val();
                var selectedCountryCode = $('#dwfrm_shippingaddress__emea_country').val();
                var custFoneNumb = util.getFormattedPhoneNumber(customFoneNumber,selectedCountryCode);
                $('#dwfrm_shippingaddress__emea_phone').val(custFoneNumb);		
            });
        },
        footerNewsletterWithCode: function() {
            $(document).on('blur','.newsletter-form-container input[class~="phonenumber"]', function() { 
                var customFoneNumber = $(this).closest('.newsletter-form-container').find('input[class~="phonenumber"]').val();
                var selectedCountryCode = $(this).closest('.newsletter-form-container').find('input[name="newsletter_country"]').val();
                var custFoneNumb = util.getFormattedPhoneNumber(customFoneNumber,selectedCountryCode);
                $(this).closest('.newsletter-form-container').find('input[class~="phone"]').val(custFoneNumb);	
            });
        },
        paraEndWithThreeDots: function (element, desktopklength, mobilelength) {
            var elementName = $(element);
            var count = $(window).width() > 991 ? desktopklength : mobilelength;
            elementName.each(function () {
                var elementNameNameVal = $(this).html();
                var elementNameNameUpdated = elementNameNameVal.slice(0, count) + (elementNameNameVal.length > count ? "..." : "");
                $(this).html(elementNameNameUpdated);
            });
        },
        /**
         * Make all .compare-attributes-item in each .product-compare-attributes (ol) have the same height as the tallest li.
         * Run this after DOM ready and after any dynamic update.
         */
        setCompareAttributesEqualHeight: function(parentselector, childselector) {
            var $columns = $(parentselector);
            if ($columns.length === 0) return;

            // Reset heights
            $columns.find(childselector).css('height', '');

            // Find the max number of rows
            var maxRows = 0;
            $columns.each(function () {
                maxRows = Math.max(maxRows, $(this).find(childselector).length);
            });

            // For each row index, find the max height and set it for all columns
            for (var row = 0; row < maxRows; row++) {
                var maxHeight = 0;
                // Find max height for this row across all columns
                $columns.each(function () {
                    var $item = $(this).find(childselector).eq(row);
                    if ($item.length) {
                        maxHeight = Math.max(maxHeight, $item.outerHeight());
                    }
                });
                // Set this height for all columns at this row
                $columns.each(function () {
                    var $item = $(this).find(childselector).eq(row);
                    if ($item.length) {
                        $item.css('height', maxHeight + 'px');
                    }
                });
            }
        },

    /**
    * Utility to poll for a selector until it exists, then resolve with the element.
    * @param {string} selector - jQuery selector to wait for
    * @param {number} intervalMs - Polling interval in ms
    * @returns {Promise<JQuery>}
    */
    waitForElement: function (selector, intervalMs = 500) {
        return new Promise((resolve) => {
            const interval = setInterval(() => {
                const $el = $(selector);
                if ($el.length) {       
                    clearInterval(interval);
                    resolve($el);
                }
            }, intervalMs);
        });
    },
            
    /**
	 * @function
	 * @description Highlights the partially or fully visible slides in a Slick carousel container.
	 *              Adds the 'truly-visible' class to those slides.
	 * @param {String|jQuery} $carousel - jQuery object or selector string for the Slick carousel container.
	 */
	getTrulyVisibleSlides: function ($carousel) {
		return new Promise((resolve) => {
			const $slides = $carousel.find('.slick-slide').not('.slick-cloned');
			const $images = $carousel.find('img');
			let previousVisibleIndexes = [];
			let stableCount = 0;

			function arraysEqual(array1, array2) {
				if (array1.length !== array2.length) return false;
				for (let i = 0; i < array1.length; i++) {
					if (array1[i] !== array2[i]) return false;
				}
				return true;
			}

			function checkVisibility() {
				const slickList = $carousel.find('.slick-list')[0];
				const listRect = slickList.getBoundingClientRect();
				const newlyVisible = [];

				$slides.each(function () {
					const rect = this.getBoundingClientRect();
					const isVisible = (
						rect.right > listRect.left &&
						rect.left < listRect.right
					);
					if (isVisible) {
						newlyVisible.push(this);
					}
				});

				const newIndexes = newlyVisible.map(slide => $(slide).data('slick-index')).sort();

				if (arraysEqual(newIndexes, previousVisibleIndexes)) {
					stableCount++;
					if (stableCount >= 2) {
						$slides.removeClass('truly-visible');
						$(newlyVisible).addClass('truly-visible');
						// Done, resolve promise
						resolve();
						return;
					}
				} else {
					stableCount = 0;
					previousVisibleIndexes = newIndexes;
				}
				requestAnimationFrame(checkVisibility);
			}

			// Image loading check
			const unloadedImages = $images.filter(function () {
				return !this.complete;
			});

			if (unloadedImages.length > 0) {
				let loadedCount = 0;
				unloadedImages.on('load error', function () {
					loadedCount++;
					if (loadedCount === unloadedImages.length) {
						requestAnimationFrame(checkVisibility);
					}
				});
			} else {
				// All images already loaded
				requestAnimationFrame(checkVisibility);
			}
		});
	}
};

export default util;
